import { IMixpanelEventMetadata, trackingRepository } from 'data/repositories/tracking.repository';

interface IEventMetadata {
    productAreaOrigin: string;
    element?: string;
    group?: string;
    step?: string;
    label?: string;
    text?: string;
    scenario?: string;
    timeResponsavel?: string;
    specificProperties?: Record<string, any>;
}

const mixpanelEventBuilder = ({
    productAreaOrigin,
    element,
    step,
    label,
    text,
    timeResponsavel,
    group,
    scenario,
    ...metadata
}: IEventMetadata): IMixpanelEventMetadata => ({
    'Product Area Origin': productAreaOrigin,
    Element: element ?? 'Não se aplica',
    Group: group ?? 'Não se aplica',
    Step: step ?? 'Não se aplica',
    Label: label ?? 'Não se aplica',
    Text: text ?? 'Não se aplica',
    Scenario: scenario ?? 'Não se aplica',
    'Time Responsavel': timeResponsavel ?? 'Não se aplica',
    ...metadata,
});

const track = (cb: VoidFunction) => {
    try {
        cb();
        return true;
    } catch ({ message }) {
        return false;
    }
};

export const trackingEvent = {
    pageview: (metadata: IEventMetadata) =>
        track(() => {
            trackingRepository.sendMixpanelEvent('Page Loaded', mixpanelEventBuilder(metadata));
            trackingRepository.sendGoogleAnalyticsEvent('pageview');
        }),
    elementClicked: (metadata: IEventMetadata) =>
        track(() => {
            trackingRepository.sendMixpanelEvent('Element Clicked', mixpanelEventBuilder(metadata));
        }),
    mixpanel: (event: string, metadata: IEventMetadata) =>
        track(() => {
            trackingRepository.sendMixpanelEvent(event, mixpanelEventBuilder(metadata));
        }),
    analytics: (event: string, metadata?: Record<string, any>) =>
        track(() => {
            trackingRepository.sendGoogleAnalyticsEvent(event, metadata);
        }),
};
